/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import { Link } from "react-router-dom";
import { ReactComponent as ReportProblemIcon } from "cms/assets/icons/exclamation-triangle.svg";

const ReportProblemLink = () => {

    return (
        <Link to='#' title='Report a Problem'>
            <ReportProblemIcon alt='report-problem-icon' />
            Report a Problem
        </Link>
    );
};

export { ReportProblemLink };
